import {
  HeartPulse,
  Umbrella,
  BriefcaseBusiness,
  LifeBuoy,
  GitCompareArrows,
} from "lucide-react";
import PageHero from "../../components/shared/PageHero";
import CtaBand from "../../components/shared/CtaBand";
import "./InsurancePage.css";

const SECTIONS = [
  {
    icon: HeartPulse,
    title: "Health Insurance",
    desc: "Family floater and individual covers reviewed for waiting periods, room rent caps, and network hospitals — protection that matches real medical costs.",
  },
  {
    icon: Umbrella,
    title: "Life Insurance",
    desc: "Term and life covers sized to income replacement and liabilities — so your family's financial plan stays intact.",
  },
  {
    icon: BriefcaseBusiness,
    title: "Business Insurance",
    desc: "Fire, liability, and key business covers to protect operations, assets, and continuity for SMEs and growing firms.",
  },
  {
    icon: LifeBuoy,
    title: "Claim Assistance",
    desc: "Guidance through documentation and insurer communication when claims arise — support when it matters most.",
  },
  {
    icon: GitCompareArrows,
    title: "Policy Comparison",
    desc: "Side-by-side comparison of features, exclusions, and premiums so you choose cover — not just the cheapest quote.",
  },
];

export default function InsurancePage() {
  return (
    <div className="ins-page">
      <PageHero
        badge="Insurance"
        title="Protection that supports your wealth plan"
        subtitle="Health, life, and business cover with policy comparison and claim assistance — so growth and protection move together."
        actions={[
          { label: "Book Free Consultation", to: "/contact", primary: true },
          { label: "Talk to an Expert", to: "/contact" },
        ]}
      />

      <section className="pm-section ins-section">
        <div className="pm-container">
          <span className="pm-badge">
            <span className="pm-badge-dot" />
            Coverage & Support
          </span>
          <h2 className="pm-section-title">Insurance services</h2>
          <p className="pm-section-sub">
            Right-sized protection with clear comparisons and claim support.
          </p>

          <div className="ins-grid">
            {SECTIONS.map((s) => {
              const Icon = s.icon;
              return (
                <article key={s.title} className="pm-card ins-card">
                  <div className="ins-card__icon">
                    <Icon size={22} />
                  </div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <CtaBand
        title="Need a policy review or fresh cover?"
        subtitle="We'll compare options and recommend protection aligned to your family or business needs."
        primary={{ label: "Book Free Consultation", to: "/contact" }}
        secondary={{ label: "Talk to an Expert", to: "/contact" }}
      />
    </div>
  );
}
